export const VERIFIED_DATE = '2026-10-09';
export const VERIFIED_DATE_LABEL = 'October 9, 2026';

export const DISCOVERY_PAGES = [
  { path: '/guides/lgnd-80eighty-sweepstakes', label: 'Merchandise sweepstakes: LGND, 80Eighty and other brands', seoTitle: 'LGND & 80Eighty-Style Sweepstakes Guide | Clean Sweeps' },
  { path: '/guides/sweepstakes-administration-companies', label: '10 sweepstakes administration companies to compare', seoTitle: '10 Sweepstakes Administration Companies | Clean Sweeps' },
  { path: '/compare/clean-sweeps-vs-viralsweep', label: 'Clean Sweeps vs ViralSweep', seoTitle: 'Clean Sweeps vs ViralSweep: Pricing & Features' },
  { path: '/compare/clean-sweeps-vs-pineraffle', label: 'Clean Sweeps vs PineRaffle', seoTitle: 'Clean Sweeps vs PineRaffle: Pricing & Features' },
];

export function installUrl(path) {
  const params = new URLSearchParams({
    utm_source: 'cleansweeps.app',
    utm_medium: 'referral',
    utm_campaign: 'sweepstakes_discovery',
    utm_content: path.split('/').filter(Boolean).join('_'),
  });
  return `https://apps.shopify.com/clean-sweeps?${params}`;
}

export const SETUP_REQUEST_URL = `mailto:info@cleansweeps.app?subject=${encodeURIComponent('Free first-campaign setup request')}&body=${encodeURIComponent('Store URL: \nClean Sweeps plan: \nCampaign goals and planned launch date: \nHelp needed with entry rules or widgets: \n')}`;
